// FIX-11：XSS 防护——所有 v-html 渲染统一经 DOMPurify 清洗后再插入
import DOMPurify from 'dompurify'

const sanitize = html => {
  if (html === null || html === undefined) return ''
  // DOMPurify 默认即移除 script/事件属性/javascript: 协议；
  // 此处再显式禁掉 style（表达式）、表单与框架类标签，并放行 a 的 target
  return DOMPurify.sanitize(String(html), {
    ADD_ATTR: ['target'],
    FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form', 'style', 'link', 'meta', 'base'],
    FORBID_ATTR: ['formaction', 'xlink:href', 'srcdoc']
  })
}

export default sanitize
